module.exports = "/fast-coin/img/coin/anim/in/coin_in_006.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_006.png
// module id = 2276
// module chunks = 5